import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NoArchiveContent } from 'view/organisms';
import { Text, BackLink } from 'view/atoms';
import { ROUTES } from 'config';
import * as S from './NoActivePage.styles';

export const NoActivePage = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(ROUTES.main);
  };

  return (
    <S.NoArchivePage>
      <BackLink action={() => navigate(-1)} />
      <NoArchiveContent
        title={t('noActiveDiscountPage.title')}
        description={t('noActiveDiscountPage.description')}
      >
        <S.GoHomeButton type='submit' kind='primary' onClick={handleClick}>
          <Text kind='button' color='gray1'>
            {t('noActiveDiscountPage.buttonText')}
          </Text>
        </S.GoHomeButton>
      </NoArchiveContent>
    </S.NoArchivePage>
  );
};
